// Centralized filter color mappings
// Single source of truth for filter type to color mapping
export const FILTER_TYPES = {
  genomic: { color: "green", group: "location", order: 0 },
  gene_symbol: { color: "blue", group: "location", order: 1 },
  attribute: { color: "yellow", group: "properties", order: 0 },
};

export const FILTER_GROUPS = {
  location: {
    title: "Genomic Ranges & Genes",
    types: ["genomic", "gene_symbol"],
    order: 0,
  },
  properties: {
    title: "Variant Attributes",
    types: ["attribute"],
    order: 1,
  },
};

// Get color variant for a filter type
export const getFilterVariant = (filterType) => {
  return FILTER_TYPES[filterType]?.color || "gray";
};

// Get sidebar section variant based on active filters
export const getSidebarSectionVariant = (sectionType, filter_results) => {
  if (!filter_results || filter_results.length === 0) return null;

  const typeMapping = {
    range: ["genomic"],
    symbol: ["gene_symbol"],
    attribute: ["attribute"],
  };

  const filterTypes = typeMapping[sectionType];
  if (!filterTypes) return null;


  const hasActiveFilter = filter_results.some((filter) =>
    filterTypes.includes(filter.type)
  );

  if (!hasActiveFilter) return null;

  // Get the color for the primary filter type
  const primaryType = filterTypes[0];
  return getFilterVariant(primaryType);
};
